<app-feather-icons [icon]="'message-square'" (click)="toggleMessageBox()"></app-feather-icons>
<ul class="chat-dropdown onhover-show-div" [class.active]="openMessageBox">
  <li>
    <app-feather-icons [icon]="'message-square'"></app-feather-icons>
    <h6 class="f-18 mb-0">{{ 'Message Box' | translate }}</h6>
  </li>
  <li>
    <div class="media"><img class="img-fluid rounded-circle me-3" src="assets/images/user/1.jpg" alt="">
      <div class="status-circle online"></div>
      <div class="media-body"><span>{{ 'Erica Hughes' | translate }}</span>
        <p>{{ 'Lorem Ipsum is simply dummy...' | translate }}</p>
      </div>
      <p class="f-12 font-success">{{ '58 mins ago' | translate }}</p>
    </div>
  </li>
  <li>
    <div class="media"><img class="img-fluid rounded-circle me-3" src="assets/images/user/2.jpg" alt="">
      <div class="status-circle online"></div>
      <div class="media-body"><span>{{ 'Kori Thomas' | translate }}</span>
        <p>{{ 'Lorem Ipsum is simply dummy...' | translate }}</p>
      </div>
      <p class="f-12 font-success">{{ '1 hr ago' | translate }}</p>
    </div>
  </li>
  <li>
    <div class="media"><img class="img-fluid rounded-circle me-3" src="assets/images/user/4.jpg" alt="">
      <div class="status-circle offline"></div>
      <div class="media-body"><span>{{ 'Ain Chavez' | translate }}</span>
        <p>{{ 'Lorem Ipsum is simply dummy...' | translate }}</p>
      </div>
      <p class="f-12 font-danger">{{ '32 mins ago' | translate }}</p>
    </div>
  </li>
  <li class="text-center"> <a class="btn btn-primary" href="/chat">{{ 'View All' | translate }}</a></li>
</ul>